import React, { useState, useEffect } from 'react';

const Pageloader = () => {
    const [isVisible, setIsVisible] = useState(true);

    const closeLoader = () => {
        setIsVisible(false);
    };
 
    if (!isVisible) return null;

    return (
        <div className="mainsld-overlay">
             <video src="https://webapi.entab.info/api/image/SFSAP/public/Images/Video.mp4" loop="" autoplay=""
            muted></video>


            {/* <video width="100%" height="1800" autoplay muted loop > 
                <source src="/Images/video.mp4"  type="video/mp4"/> 
            </video>  */}
            <div className="closeLoader" onClick={closeLoader}>
                <i className="bi bi-x"></i>
            </div>
            <div class="data">
  <img src="https://webapi.entab.info/api/image/SFSAP/public/Images/video-logo.png" alt="st Francis Amritsar" />
  <h1>St. Francis School, Amritsar <span>Grace and Wisdom</span></h1>
  </div>
           
        </div>
    );
};

export default Pageloader;
